import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    display: 'flex',
    padding: theme.spacing(2, 0),
    alignItems: 'center',
  },

  imageContainer: {
    width: theme.spacing(10),
    height: theme.spacing(5),
    marginRight: theme.spacing(2),

    '& img': {
      width: '100%',
      height: '100%',
    },
  },

  titleContainer: {
    display: 'flex',
    flexDirection: 'column',
  },

  note: {
    color: theme.palette.text.disabled,

    '&.MuiTypography-root': {
      fontSize: theme.spacing(1.5),
    },
  },
}));
